<ng-container *ngFor="let p of programs; trackBy: trackById">
  <expanding-wrapper
    class="program"
    *ngIf="{ date: p | programDayDate, 
      roomToggleKey: p.id + ':room',  
      venue: (logisticsEvent.venues || {})[p.venueId],
      assets: p.assetIds | idsToItems:logisticsEvent.assets,
      exhibitorStands: ((exhibitorStandIdsByProgramId || {})[p.id]) | idsToItems: logisticsEvent.exhibitorStands
    } as pVars"
    [padded]="true"
    [expandedState]="!expandedStates[p.id] ? 'collapse' : 'expand'"
    [manualToggle]="true"
    (onToggle)="expandedStates[p.id] = !expandedStates[p.id]"
    [borderGreyOnCollapse]="true"
  >
    <div class="header-left">
      <div class="times-labels">
        <h4 [ngClass]="{ missing: !p.title }">{{ p.title || 'Unnamed Room/Location' }}</h4>
        <labels-view *ngIf="!!p.labels?.length" [labelMap]="program_labels" [labels]="p.labels"></labels-view>
      </div>
    </div>
    <div class="header-right toggle-menu" (click)="$event.stopPropagation()" *ngIf="expandedStates[p.id]">
      <icon [icon]="'grow'" (click)="$event.stopPropagation(); expandProgram(p)"></icon>
      <icon [icon]="'shrink'" (click)="$event.stopPropagation(); collapseProgram(p)"></icon>
    </div>
    <expanding-wrapper
      class="program"
      *ngIf="!excludedFieldIds.includes(DOIds.roomTab)"
      [padded]="true"
      [title]="'Room/location logistics'"
      [expandedState]="!expandedStates[pVars.roomToggleKey] ? 'collapse' : 'expand'"
      [manualToggle]="true"
      (onToggle)="expandedStates[pVars.roomToggleKey] = !expandedStates[pVars.roomToggleKey]"
      [borderGreyOnCollapse]="true"
    >
      <div class="columns">
        <div class="left">
          <subtitle-wrapper class="title" [title]="'ROOM/LOCATION NICKNAME'" [emptyText]="p.title ? '' : 'No room/location nickname'">
            {{ p.title }}
          </subtitle-wrapper>
          <subtitle-wrapper *ngIf="!excludedFieldIds.includes(DOIds.roomDate)" [title]="'DATE'" [emptyText]="!pVars.date.includes('Day') ? '' : pVars.date">
            <ng-container *ngIf="!pVars.date.includes('Day')"> {{ pVars.date }}</ng-container>
          </subtitle-wrapper>
          <subtitle-wrapper *ngIf="!excludedFieldIds.includes(DOIds.assets) && !!pVars.assets.length" [title]="'ROOM/LOCATION ASSETS'">
            <asset-link *ngFor="let asset of pVars.assets"
              (click)="$event.stopPropagation()"
              [asset]="asset"
              [onlyLink]="true"
            ></asset-link>
          </subtitle-wrapper>
          <subtitle-wrapper 
            *ngIf="!excludedFieldIds.includes(DOIds.roomExhibitors) && pVars.exhibitorStands?.length" [title]="'Exhibitor Information'">

            <expanding-wrapper *ngFor="let stand of pVars.exhibitorStands; let i = index"
              class="exhibitorStands"
              [padded]="true"
              [borderGreyOnCollapse]="true"
              [expandedState]="!expandedStates[pVars.roomToggleKey + 'exhibitor_stand_' + i] ? 'collapse' : 'expand'"
              [manualToggle]="true"
              (onToggle)="expandedStates[pVars.roomToggleKey + 'exhibitor_stand_' + i] = !expandedStates[pVars.roomToggleKey + 'exhibitor_stand_' + i]"
              [title]="stand?.name"
            >
              <div class="header-left">{{ logisticsEvent.standTypes[stand.standTypeId]?.name }}</div>
              <div class="header-right" *ngIf="logisticsEvent.exhibitors[stand.exhibitorId] as exhibitor">
                <photo [size]="24" [logo]="true" [data]="{title:exhibitor?.name, photoURL: exhibitor.logoUrl}"></photo>
                {{ exhibitor?.name }}
              </div>
              <subtitle-wrapper [title]="'Stand notes'" *ngIf="!!stand.standNotes">
                <div>{{ stand.standNotes }}</div>
              </subtitle-wrapper>
              <subtitle-wrapper [title]="'Stand requests'" *ngIf="!!stand.requests.length">
                <div *ngFor="let request of stand.requests">{{ request.requestText }}</div>
              </subtitle-wrapper>
            </expanding-wrapper>
          </subtitle-wrapper>
        </div>
        <div class="right">
          <subtitle-wrapper *ngIf="!excludedFieldIds.includes(DOIds.venueDetails) && !!pVars.venue" [title]="'VENUE DETAILS'">
            <grey-card *ngIf="!!pVars.venue">
              <ng-container *ngIf="!!p.location"><div class="bold" *ngIf="p.location">{{ p.location }}</div></ng-container>
              <div (click)="helpers.openInNewTab('https://www.google.com/maps/place/?q=place_id:' + pVars.venue.googleId)" class="secondary_link">{{ pVars.venue.venue }}</div>
              <div>{{ pVars.venue.address }}</div>
              <h5 style="margin-top: 10px">TIME ZONE</h5>
              <div class="time-zone" *ngIf="!p.secondaryTimeZoneDetails">
                {{ p.timeZoneDetails.abbr }} (GMT {{ p.timeZoneDetails.offsetText }})
              </div>
              <div class="time-zone" *ngIf="p.secondaryTimeZoneDetails">
                {{ p.secondaryTimeZoneDetails.abbr }} (GMT {{ p.secondaryTimeZoneDetails.offsetText }})
              </div>
            </grey-card>
          </subtitle-wrapper>
          <tag-panel-view
            *ngIf="!excludedFieldIds.includes(DOIds.roomTags)"
            [tagData]="tagDataMap[p.id]"
            [readOnly]="true"
            [noHeaders]="false"
            [fromLogistics]="true"
            [performers]="logisticsEvent?.performers"
            [sponsors]="logisticsEvent?.sponsors"
            [exhibitors]="logisticsEvent?.exhibitors"
            [resources]="logisticsEvent?.resources"
            [workforce]="logisticsEvent?.workforce"
            [attendees]="logisticsEvent?.attendees"
          ></tag-panel-view>
        </div>
      </div>
    </expanding-wrapper>
    <ng-container *ngIf="!excludedFieldIds.includes(DOIds.setupTab)">
      <h5 class="sessions-header" [ngClass]="{ alone: excludedFieldIds.includes(DOIds.roomTab) && excludedFieldIds.includes(DOIds.sessionsTab) }">SETUPS</h5>
      <div class="empty" *ngIf="!p.setupIds?.length">No setups!</div>
      <ng-container *ngFor="let setup of p.setupIds | idsToItems:p.setups">
        <expanding-wrapper
          class="session"
          *ngIf="{ accessDate: p | programDayDate:setup.accessDay + 1:true, clearDate: p | programDayDate:setup.clearDay + 1:true, toggleKey: p.id + ':' + setup.id } as sVars"
          [padded]="true"
          [borderGreyOnCollapse]="true"
          [expandedState]="!expandedStates[sVars.toggleKey] ? 'collapse' : 'expand'"
          [manualToggle]="true"
          (onToggle)="expandedStates[sVars.toggleKey] = !expandedStates[sVars.toggleKey]"
        >
          <div class="header-left">
            <div class="times-labels" *ngIf="(setup.access || setup.accessDay || setup.clear || setup.clearDay) && (!excludedFieldIds.includes(DOIds.access) || !excludedFieldIds.includes(DOIds.clear))">
              <h5>
                <ng-container *ngIf="!!setup.access" >{{ setup.access | justTimeToHHMM:true }}</ng-container>
                <ng-container *ngIf="!!sVars.accessDate && !excludedFieldIds.includes(DOIds.access) && sVars.accessDate !== sVars.clearDate">
                  <ng-container *ngIf="!!setup.access && !excludedFieldIds.includes(DOIds.access)">, </ng-container>{{ sVars.accessDate }}
                </ng-container> 
                <ng-container *ngIf="!!sVars.accessDate && !excludedFieldIds.includes(DOIds.access) && !!setup.clear && !excludedFieldIds.includes(DOIds.clear)"> - </ng-container>
                <ng-container *ngIf="!!setup.clear && !excludedFieldIds.includes(DOIds.clear)">{{ setup.clear | justTimeToHHMM:true }}</ng-container>
                <ng-container *ngIf="!!sVars.clearDate && !excludedFieldIds.includes(DOIds.clear)">
                  <ng-container *ngIf="!!setup.clear && !excludedFieldIds.includes(DOIds.clear)">, </ng-container>{{ sVars.clearDate }}
                </ng-container> 
              </h5>
            </div>
            <h4 [ngClass]="{ missing: !setup.name }">{{ setup.name || 'Untitled Setup' }}</h4> 
          </div>
          <div class="columns" *ngIf="expandedStates[sVars.toggleKey] && {
            sessionTags: setup.sessionIds | idsToTagData:sessionMap,
            assets: setup.assetIds | idsToItems:logisticsEvent.assets
          } as setupVars">
            <div class="left">
              <subtitle-wrapper class="title" [title]="'SETUP NAME'">
                {{ setup.name || 'Untitled Setup' }}
              </subtitle-wrapper>
              <subtitle-wrapper *ngIf="!excludedFieldIds.includes(DOIds.roomSetup) && !!setup.setup" [title]="'SETUP'">
                <div *ngIf="!!setup.setup" [innerHTML]="helpers.strWithBreak(setup.setup)"></div>
              </subtitle-wrapper>    
              <subtitle-wrapper class="notes" *ngIf="!excludedFieldIds.includes(DOIds.setupNotes) && !!setup.notes?.length" [title]="'SETUP NOTES'">
                <public-informable
                  [itemsInitClosed]="true"
                  [singleSectionOnly]="true"
                  [showEmptyItems]="true"
                  [information]="[{ id: 'setupNotes', title: 'Setup notes', items: setup.notes, placeholder: 'No setup notes'}]"
                ></public-informable>
              </subtitle-wrapper>
              <subtitle-wrapper *ngIf="!excludedFieldIds.includes(DOIds.setupSessions) && setupVars.sessionTags?.length" [title]="'ASSOCIATED SESSIONS'">
                <on-sessions-view 
                  [readOnly]="true"
                  [tags]="setupVars.sessionTags"
                ></on-sessions-view>
              </subtitle-wrapper>
            </div>
            <div class="right">
              <subtitle-wrapper *ngIf="!excludedFieldIds.includes(DOIds.expectedNumbers) && !!setup.expected" [title]="'EXPECTED NUMBERS'">
                <div [innerHTML]="helpers.strWithBreak(setup.expected)"></div>
              </subtitle-wrapper>
              <subtitle-wrapper *ngIf="!excludedFieldIds.includes(DOIds.capacity) && !!setup.capacity" [title]="'CAPACITY'">
                <div [innerHTML]="helpers.strWithBreak(setup.capacity)"></div>
              </subtitle-wrapper>
              <subtitle-wrapper *ngIf="!excludedFieldIds.includes(DOIds.access) && !!(setup.access || setup.accessDay)" [title]="'ACCESS'">
                <ng-container >{{ setup.access | justTimeToHHMM:true }}</ng-container>
                <ng-container *ngIf="!!sVars.accessDate && !excludedFieldIds.includes(DOIds.access) && sVars.accessDate !== sVars.clearDate">
                  <ng-container *ngIf="!!setup.access && !excludedFieldIds.includes(DOIds.access)">, </ng-container>{{ sVars.accessDate }}
                </ng-container> 
              </subtitle-wrapper>
              <subtitle-wrapper *ngIf="!excludedFieldIds.includes(DOIds.clear) && !!(setup.clear || setup.clearDay)" [title]="'CLEARED'">
                <ng-container *ngIf="!!setup.clear && !excludedFieldIds.includes(DOIds.clear)">{{ setup.clear | justTimeToHHMM:true }}</ng-container>
                <ng-container *ngIf="!!sVars.clearDate && !excludedFieldIds.includes(DOIds.clear)">
                  <ng-container *ngIf="!!setup.clear && !excludedFieldIds.includes(DOIds.clear)">, </ng-container>{{ sVars.clearDate }}
                </ng-container> 
              </subtitle-wrapper>
              <subtitle-wrapper *ngIf="!excludedFieldIds.includes(DOIds.setupAssets) && !!setupVars.assets?.length" [title]="'SETUP ASSETS'">
                <asset-link *ngFor="let asset of setupVars.assets"
                  (click)="$event.stopPropagation()"
                  [asset]="asset"
                  [onlyLink]="true"
                ></asset-link>
              </subtitle-wrapper>
            </div>
          </div>
        </expanding-wrapper>
      </ng-container><!-- End Setup -->
    </ng-container><!-- End Setups -->
    <ng-container *ngIf="!excludedFieldIds.includes(DOIds.sessionsTab)">
      <h5 class="sessions-header" [ngClass]="{ alone: excludedFieldIds.includes(DOIds.roomTab) }">SESSIONS</h5>
      <div class="empty" *ngIf="!p.sessions.length">No sessions!</div>
      <ng-container *ngFor="let programDay of p.sessions; trackBy: trackByIndex">
        <ng-container *ngFor="let sessionId of programDay.sessions">
          <ng-container *ngIf="p.sessions_obj[sessionId].type != 'break' && p.sessions_obj[sessionId] as s">
            <expanding-wrapper
              class="session"
              *ngIf="{ 
                date: p | programDayDate:programDay.day:true, toggleKey: p.id + ':' + sessionId, 
                sponsors: s.sponsorIds | idsToItems:logisticsEvent?.sponsors, 
                performers: s.performerIds | idsToItems:logisticsEvent?.performers,
                assets: s.assetIds | idsToItems:logisticsEvent.assets,
                stagingRequests: s.stagingRequests | validSortedStagingRequests:logisticsEvent.performers
              } as sVars"
              [padded]="true"
              [borderGreyOnCollapse]="true"
              [expandedState]="!expandedStates[sVars.toggleKey] ? 'collapse' : 'expand'"
              [manualToggle]="true"
              (onToggle)="expandedStates[sVars.toggleKey] = !expandedStates[sVars.toggleKey]"
            >
            
              <div class="header-left">
                <div class="times-labels">
                  <h5>{{ s.start }} - {{ s.end }}, {{ sVars.date }}</h5>
                  <labels-view *ngIf="!!s.labels?.length" [labelMap]="session_labels" [labels]="s.labels"></labels-view>
                </div>
                <h4 [ngClass]="{ missing: !s.title }">{{ s.title || 'Untitled Session' }}</h4> 
              </div>
              <div class="columns" *ngIf="expandedStates[sVars.toggleKey]">
                <div class="left">
                  <subtitle-wrapper class="title" [title]="'SESSION TITLE'" [emptyText]="s.title ? '' : 'No session title'">
                    {{ s.title }}
                  </subtitle-wrapper>
                  <subtitle-wrapper *ngIf="!!s.description && !excludedFieldIds.includes(DOIds.sessionDescription)" [title]="'SESSION DESCRIPTION'">
                    <div class="" [innerHTML]="s.description"></div>
                  </subtitle-wrapper>
                  <subtitle-wrapper class="notes" *ngIf="!excludedFieldIds.includes(DOIds.performerBriefNotes) && !!s.presentationNotes.length" [title]="'NOTES FOR PERFORMER BRIEF'">
                    <public-informable
                      [itemsInitClosed]="true"
                      [singleSectionOnly]="true"
                      [showEmptyItems]="true"
                      [information]="[{ id: 'presentationNotes', title: 'Presentation notes for performer brief', items: s.presentationNotes || [], placeholder: 'No notes'}]"
                    ></public-informable>
                  </subtitle-wrapper>
                  <subtitle-wrapper *ngIf="!excludedFieldIds.includes(DOIds.presentationAssets) && !!sVars.assets.length" [title]="'SESSION ASSETS'">
                    <asset-link *ngFor="let asset of sVars.assets"
                      (click)="$event.stopPropagation()"
                      [asset]="asset"
                      [onlyLink]="true"
                    ></asset-link>
                  </subtitle-wrapper>
                  <subtitle-wrapper *ngIf="!excludedFieldIds.includes(DOIds.stagingRequests) && !!sVars.stagingRequests?.length" [title]="'STAGING REQUESTS'">
                    <staging-requests *ngIf="canViewStagingRequests" [stagingRequests]="sVars.stagingRequests"></staging-requests>
                    <div class="hint" *ngIf="!canViewStagingRequests" style="font-size: 14px;">You don’t have permission to see <strong>presentation assets.</strong></div>
                  </subtitle-wrapper>
                  <subtitle-wrapper *ngIf="!excludedFieldIds.includes(DOIds.stagingNotes) && !!s.notes">
                    <div [innerHTML]="helpers.strWithBreak(s.notes)"></div>
                  </subtitle-wrapper>
                  <subtitle-wrapper class="notes" *ngIf="!excludedFieldIds.includes(DOIds.stagingItems) && !!s.stagingItems?.length " [title]="'STAGING ITEMS'">
                    <public-informable
                      [itemsInitClosed]="true"
                      [singleSectionOnly]="true"
                      [showEmptyItems]="true"
                      [information]="[{ id: 'stagingItems', title: 'Staging items', items: s.stagingItems || [], placeholder: 'No staging items'}]"
                    ></public-informable>
                  </subtitle-wrapper>
                  <subtitle-wrapper *ngIf="!excludedFieldIds.includes(DOIds.stagingFiles) && !!s.files?.length" [title]="'STAGING FILES'">
                    <file-link *ngFor="let file of s.files"
                      [file]="file"
                      [onlyLink]="true"
                    ></file-link>
                  </subtitle-wrapper>
                  <subtitle-wrapper *ngIf="!excludedFieldIds.includes(DOIds.cateringNotes) && !!s.cateringNotes?.length" [title]="'CATERING NOTES'">
                    <div [innerHTML]="helpers.strWithBreak(s.cateringNotes)"></div>
                  </subtitle-wrapper>
                  <subtitle-wrapper class="notes" *ngIf="!excludedFieldIds.includes(DOIds.cateringItems) && !!s.cateringItems?.length" [title]="'CATERING ITEMS'">
                    <public-informable
                      [itemsInitClosed]="true"
                      [singleSectionOnly]="true"
                      [showEmptyItems]="true"
                      [information]="[{ id: 'cateringItems', title: 'Catering items', items: s.cateringItems || [], placeholder: 'No catering items'}]"
                    ></public-informable>
                  </subtitle-wrapper>
                  <subtitle-wrapper *ngIf="!excludedFieldIds.includes(DOIds.cateringFiles) && !!s.cateringFiles?.length" [title]="'CATERING FILES'">
                    <file-link *ngFor="let file of s.cateringFiles"
                      [file]="file"
                      [onlyLink]="true"
                    ></file-link>
                  </subtitle-wrapper>
                </div>
                <div class="right">
                  <subtitle-wrapper *ngIf="!excludedFieldIds.includes(DOIds.duration)" [title]="'DURATION'">
                    {{ s.duration || 0 }} minutes
                  </subtitle-wrapper>
                  <subtitle-wrapper *ngIf="!excludedFieldIds.includes(DOIds.publicLinks) && s.publicLinks?.length" [title]="'PUBLIC LINKS'">
                    <file-link *ngFor="let file of s.publicLinks"
                      [file]="file"
                      [onlyLink]="true"
                    ></file-link>
                  </subtitle-wrapper>
                  <subtitle-wrapper *ngIf="!excludedFieldIds.includes(DOIds.performers) && !!sVars.performers.length" [title]="'PERFORMERS'">
                    <grey-card *ngFor="let performer of sVars.performers">
                      <performer-card [performer]="performer"></performer-card>
                    </grey-card>
                  </subtitle-wrapper>
                  
                  <subtitle-wrapper *ngIf="!excludedFieldIds.includes(DOIds.sponsors) && !!sVars.sponsors.length" [title]="'SPONSORS'">
                    <grey-card *ngFor="let sponsor of sVars.sponsors">
                      <div class="bold">{{ sponsor.name }}</div>
                    </grey-card>
                  </subtitle-wrapper>
                  <tag-panel-view
                    *ngIf="!excludedFieldIds.includes(DOIds.sessionTags)"
                    [tagData]="tagDataMap[s.id]"
                    [readOnly]="true"
                    [noHeaders]="false"
                    [fromLogistics]="true"
                    [performers]="logisticsEvent?.performers"
                    [sponsors]="logisticsEvent?.sponsors"
                    [exhibitors]="logisticsEvent?.exhibitors"
                    [resources]="logisticsEvent?.resources"
                    [workforce]="logisticsEvent?.workforce"
                    [attendees]="logisticsEvent?.attendees"
                  ></tag-panel-view>
                </div>
              </div>
            </expanding-wrapper>
          </ng-container><!--End session-->
        </ng-container>
      </ng-container><!-- End program day -->
    </ng-container>

  </expanding-wrapper>
</ng-container><!--End program-->